export enum CallToActionType {
    BUTTON = "button",
    LINK = "link",
}
